import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

import './Join.css';

const Join = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_h9g0btg', 'template_5urckpa', form.current, 'GJAtl73WZaFyf9KlA')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
    };

    return (
        <div className="Join" id="join-us">
            <div className="left-j">
                <hr />
                <div>
                    <span className="stroke-text">მზად ხარ</span>
                    <span>შემდეგ საფეხურზე</span>
                </div>
                <div>
                    <span>შენი სხეულის</span>
                    <span className="stroke-text">განვითარებისთვის?</span>
                </div>
            </div>
            <div className="right-j">
                <form 
                    ref={form} 
                    className="email-container" 
                    onSubmit={sendEmail}
                >
                    <input 
                        type="email" 
                        name="user_email" 
                        placeholder="შეიყვანეთ თქვენი ელ.ფოსტის მისამართი"
                    />
                    <button className="btn btn-j">შემოგვიერთდი ახლავე</button>
                </form>
            </div>
        </div>
    );
};

export default Join;
